const phrases = {
	phoneHours: '(po - pá 9:00 - 16:00)',
	exportAnomaliesForDistributionPeriod: 'Exportovat anomálie za období $distributionPeriodId',
	exportConflictsForDistributionPeriod: 'Exportovat konflikty za období $distributionPeriodId',
	paidOn: 'Vyplaceno dne',
	eloUnavailable: 'Dokumenty jsou v tuto chvíli nedostupné, zkuste to prosím později.',
	invoiceDocumentsHeader: 'Podklady k fakturaci (prosíme, vystavte fakturu)',
	Document: 'Doklady',
	payments: 'Výplaty',
	reallyCancelAffirmationSubmission: 'Opravdu chcete zrušit podání ČP VZOZ?\n\nPo zrušení již nebude pro tento distribuční rok možné podat nové čestné prohlášení.',
	documentNoDataMessage: 'Nenalezeny žádné doklady',
	invoiceDocuments: 'Podklady pro fakturaci',
	otherInheritedRemuneration: 'ostatní zděděná práva',
	broadcasterNotSpecified: 'Vysílatel neuveden',
	nRolesSelected1: 'Vybrána $count role',
	nRolesSelected2_4: 'Vybrány $count role',
	nRolesSelected5_: 'Vybráno $count rolí',
	inNProfiles1: 'v $count profilu',
	inNProfiles2_4: 've $count profilech',
	inNProfiles5_: 'v $count profilech',
	'roleLookup.profile.ENS': 'profil souboru',
	'roleLookup.profile.PRO': 'profil výrobce',
	'roleLookup.profile.PER': 'profil umělce',
	inheritedRights: 'zděděná práva',
	ensembleShare: 'podíl ze souboru',
	'dashboard.subHeader.country': 'Země',
	cmoRewards: 'Odměny ze zahraničí',
	submissionMaxAttachmentSize: 'max. velikost souboru $singleFileSizeLimit MB, celkem za všechny přílohy $totalSizeLimit MB',
	affirmationCorrectionSubheader: 'Pokud zobrazená data neodpovídají, opravte je prosím a přidejte zdůvodnění a případně přílohu vysvětlující rozdíl. Děkujeme',
	reallySavePermanentCatalogChanges: 'Opravdu uložit provedené změny?',
	unprocessedSubmissionWithSameIsrcExists: 'Existuje nezpracované podání se stejným ISRC.',
	duplicateIsrc: 'Duplicitní ISRC',
	'recordingProtocol.sameIsrcRecordingsWarningHeader': 'Evidujeme dříve podané registrace se stejným ISRC',
	'recordingProtocol.sameIsrcRecordingWarningHeader': 'Evidujeme dříve podanou registraci se stejným ISRC',
	'catalog.sameIsrcRecordingsWarningHeader': 'Katalog nahrávek obsahuje nahrávky se stejným ISRC',
	'catalog.sameIsrcRecordingWarningHeader': 'Katalog nahrávek obsahuje nahrávku se stejným ISRC',
	'recordingProtocol.sameIsrcRecordingErrorHeader': 'Evidujeme nezpracovanou registraci se stejným ISRC',
	'recordingProtocol.sameIsrcRecordingsErrorHeader': 'Evidujeme nezpracované registrace se stejným ISRC',

	'mdb.sameIsrcRecordingWarningHeader': 'Mezi vašimi nahrávkami se nachází nahrávka se stejným ISRC',
	'mdb.sameIsrcRecordingsWarningHeader': 'Mezi vašimi nahrávkami se nachází nahrávky se stejným ISRC',
	'mdb.adminSameIsrcRecordingWarningHeader': 'V MDB evidujeme nahrávku se stejným ISRC',

	'recordingProtocolMessage#validationErrors': 'Při zpracování došlo k chybám',
	'recordingProtocolMessage#catalogProviderIsNotAProducer': 'Výrobce není evidován jako poskytovatel katalogů.',
	'recordingProtocolMessage#verr_disr':'Duplicitní ISRC',
	'recordingProtocolMessage#verr_eccs':'Neshoda ZKS u všech umělců',
	'recordingProtocolMessage#verr_eces':'Neshoda ZKS nebo prázdný tag Claiming Society u všech umělců',
	'recordingProtocolMessage#verr_eecs':'Prázdný tag Claiming Society u všech umělců',
	'recordingProtocolMessage#verr_elic':'Neplatné datum licence',
	'recordingProtocolMessage#verr_elup':'Žádný člen lineupu bez chyb',
	'recordingProtocolMessage#verr_icop':'Neplatná koprodukce',
	'recordingProtocolMessage#verr_icpe':'Neplatný potvrzený výkon',
	'recordingProtocolMessage#verr_ictr':'Neplatný kód země',
	'recordingProtocolMessage#verr_idob':'Neplatné datum narození',
	'recordingProtocolMessage#verr_iend':'Neplatné datum do',
	'recordingProtocolMessage#verr_igen':'Neplatné pohlaví',
	'recordingProtocolMessage#verr_ignr':'Neplatný žánr',
	'recordingProtocolMessage#verr_iipn':'Neplatné IPN',
	'recordingProtocolMessage#verr_iisr':'Neplatné ISRC',
	'recordingProtocolMessage#verr_ilai':'Neplatné Id labelu',
	'recordingProtocolMessage#verr_ilic':'Neplatné datum licence',
	'recordingProtocolMessage#verr_inum':'Neplatné číslo',
	'recordingProtocolMessage#verr_ipei':'Neplatné Id výkonného umělce',
	'recordingProtocolMessage#verr_ipin':'Neplatné rodné číslo',
	'recordingProtocolMessage#verr_ipri':'Neplatné Id výrobce',
	'recordingProtocolMessage#verr_iprs':'Neplatný podíl výrobce',
	'recordingProtocolMessage#verr_ipyr':'Neplatný rok výroby',
	'recordingProtocolMessage#verr_iret':'Neplatný typ nahrávky',
	'recordingProtocolMessage#verr_irol':'Neplatný výkon',
	'recordingProtocolMessage#verr_irun':'Neplatná stopáž',
	'recordingProtocolMessage#verr_iryr':'Neplatný rok vydání',
	'recordingProtocolMessage#verr_ishr':'Neplatný podíl',
	'recordingProtocolMessage#verr_isht':'Neplatný součet podílů',
	'recordingProtocolMessage#verr_istd':'Neplatné datum od',
	'recordingProtocolMessage#verr_itex':'Součet ITG odměn neodpovídá celkové odměně',
	'recordingProtocolMessage#verr_mamt':'Chybějící částka',
	'recordingProtocolMessage#verr_mbap':'Chybějící datum narození/rodné čislo',
	'recordingProtocolMessage#verr_mcor':'Chybějící země pobytu',
	'recordingProtocolMessage#verr_mdob':'Chybějící datum narození',
	'recordingProtocolMessage#verr_mgid':'Chybějící Id skupiny',
	'recordingProtocolMessage#verr_mlab':'Chybějící label',
	'recordingProtocolMessage#verr_mlai':'Chybějící Id labelu',
	'recordingProtocolMessage#verr_mlic':'Chybějící licence',
	'recordingProtocolMessage#verr_mnam':'Chybějící jméno',
	'recordingProtocolMessage#verr_mpei':'Chybějící Id umělce',
	'recordingProtocolMessage#verr_mper':'Chybějící výkonný umělec',
	'recordingProtocolMessage#verr_mpfn':'Chybějící jméno umělce',
	'recordingProtocolMessage#verr_mpln':'Chybějící příjmení umělce',
	'recordingProtocolMessage#verr_mpri':'Chybějící Id výrobce',
	'recordingProtocolMessage#verr_mpro':'Chybějící výrobce',
	'recordingProtocolMessage#verr_mpry':'Chybějící rok výroby/vydání',
	'recordingProtocolMessage#verr_mros':'Chybějící role/podíl',
	'recordingProtocolMessage#verr_mrun':'Chybějící stopáž',
	'recordingProtocolMessage#verr_mtit':'Chybějící název',
	'recordingProtocolMessage#verr_unpr':'Nechráněná nahrávka',
	'recordingProtocolMessage#verr_wccs':'Neshoda ZKS u umělců',
	'recordingProtocolMessage#verr_wecs':'Prázdný tag Claiming Society u umělců',
	'recordingProtocolMessage#verr_wisr':'Neplatné ISRC',
	'recordingProtocolMessage#verr_wixn':'Id neodpovídá jménu',
	'recordingProtocolMessage#verr_wlnm':'Neshoda ve jménu labelu',
	'recordingProtocolMessage#verr_wlup':'Člen(ové) lineupu s chybama',
	'recordingProtocolMessage#verr_wper':'Chybějící výkonný umělec',
	'recordingProtocolMessage#verr_wpnm':'Neshoda ve jménu výrobce',
	'recordingProtocolMessage#verr_wrun':'Bez stopáže',
	copyMoviesFromPreviousYear: 'Načíst filmy z loňského ČP',
	'submissionResolution.Y': 'Vyřešeno',
	'submissionResolution.N': 'Nevyřešeno',
	recordingModificationsAwaitProcessing: 'Provedené změny čekají na zpracování',
	'recordingProtocol.invalidACRoleCombination': 'Role A a C nemohou být společně na lineupu bez toho, aby na něm byla i role B.',
	licences: 'Licence',
	removeRecordingFromCatalog: 'Odstranit nahrávku z katalogu',
	reallyRemoveRecordingFromCatalog: 'Opravdu chcete odstranit nahrávku z katalogu?',
	permanentCatalogDetail: 'Detail nahrávky',
	invalidPinDob: 'Neplatný formát RČ/dat.nar.',
	invalidISRC: 'Neplatný formát ISRC',
	approve: 'Schválit',
	reallyApproveRecordingProtocol: 'Opravdu schválit nahrávací protokol?',
	'recordingProtocolAdminStatusComments.deny': 'Zdůvodnění zamítnutí',
	'recordingProtocolAdminStatusComments.return': 'Zdůvodnění vrácení',
	return: 'Vrátit',
	deny: 'Zamítnout',
	RecordingProtocolAdmin: 'Správa nahrávacích protokolů',
	'recordingProtocol.aloPerormer': 'Zadejte alespoň jednoho umělce podílejícího se na nahrávce.',
	'shareOrRoleOrNothing.S': 'Podíl',
	'shareOrRoleOrNothing.R': 'Role',
	'shareOrRoleOrNothing.N': 'Ani jedno',
	recordingProtocolCLSMissingComposer: 'Pokud nebude autor hudby vyplněn, nelze nárokovat odměny ze zahraničí.',
	'recordingProtocolCopyButtonHeader.album': 'Registrovat další nahrávku na albu',
	'recordingProtocolCopyButtonText.album': 'Bude vytvořena kopie této nahrávky s prázdným ISRC, titulem a stopáží.',
	'recordingProtocolCopyButtonHeader.empty': 'Registrovat další nahrávku',
	'recordingProtocolCopyButtonText.empty': 'Bude vytvořena prázdná nahrávka.',
	'recordingProtocolCopyButtonHeader.video': 'Registrovat video verzi nahrávky',
	'recordingProtocolCopyButtonText.video': 'Bude vytvořena kopie této nahrávky s typem nastaveným na "Videoklip"',
	'recordingProtocolCopyButtonHeader.exact': 'Vytvořit kopii nahrávky',
	'recordingProtocolCopyButtonText.exact': 'Bude vytvořena kopie této nahrávky se zachováním všech údajů.',
	reallyProceedToLineupNoIsrc: 'Opravdu chcete pokračovat? Pokud nebude vyplněn ISRC, bude nahrávka zaregistrována s nižší relevancí než nahrávací protokol.',
	reallyCloseModifiedRecordingProtocolDetail: 'Opravdu chcete zavřít záložku?\n\nProvedené změny budou zahozeny.',
	reallyCloseModifiedPermanentCatalogRecordingDetail: 'Opravdu chcete zavřít záložku?\n\nProvedené změny budou zahozeny.',
	submitRecordingProtocol: 'Registrovat nahrávku',
	'recordingProtocolDeclaration.PRO': 'Potvrzuji správnost a úplnost uvedených výkonů z pozice výrobce náhrávky.',
	'recordingProtocolDeclaration.ADM': 'Potvrzuji správnost a úplnost uvedených výkonů z pozice společného zástupce souboru.',
	'recordingProtocolDeclaration.PER': 'Potvrzuji správnost uvedených údajů z pozice výkonného umělce participujícího na nahrávce.',
	'recordingProtocolDeclaration.PER.hint': 'Beru na vědomí, že nahrávka bude registrována s nižší relevancí a s možností pozdější editace dalšími nositeli práv či uživateli.',
	'creatorRole.PER.POP.A': 'A - Sólista',
	'creatorRole.PER.POP.B': 'B - Hlavní výkon',
	'creatorRole.PER.POP.C': 'C - Vedlejší výkon',
	'creatorRole.PER.CLS.D': 'D - Sólista',
	'creatorRole.PER.CLS.E': 'E - Dirigent',
	'creatorRole.PER.CLS.F': 'F - Sbormistr',
	'creatorRole.PER.CLS.G': 'G - Člen orchestru',
	'creatorRole.PER.CLS.H': 'H - Člen sboru',
	'creatorRole.PER.CLS.I': 'I - Člen komorního souboru',
	'creatorRole.PER.POP.X': 'X - Neznámý výkon',
	'creatorRole.PER.CLS.Y': 'Y - Neznámý výkon',
	totalShareMustBe100: 'Celkový podíl musí být 100%',
	'recordingProtocol.composers': 'Autoři hudby',
	'recordingProtocol.lyricists': 'Autoři textu',
	'recordingProtocol.performers': 'Umělci podílející se na nahrávce',
	'recordingProtocol.authors': 'Autoři',
	'recordingProtocolAuthorRole.AH': 'Autor hudby',
	'recordingProtocolAuthorRole.AT': 'Autor textu',
	correctTheFollowingErrors: 'Opravte prosím následující chyby',
	'recordingProtocolGenre.POP': 'Populární hudba',
	'recordingProtocolGenre.CLS': 'Klasická hudba',

	'catalogPerformance.1': '1 - zpěvák',
	'catalogPerformance.2': '2 - hudebník',
	'catalogPerformance.3': '3 - muzikant',
	'catalogPerformance.4': '4 - dirigent',
	'catalogPerformance.5': '5 - tanečník',
	'catalogPerformance.6': '6 - herec',
	'catalogPerformance.7': '7 - skupina',
	'catalogPerformance.8': '8 - orchestr',
	'catalogPerformance.9': '9 - sbor',
	'catalogPerformance.12': '12 - komorní orchestr',


	'genre.POP': 'Populární hudba',
	'genre.CLS': 'Klasická hudba',
	'genre.SPK': 'Mluvené slovo',
	releaseOrProductionYearIsMandatory: 'Rok vzniku nebo prvního vydání je povinný',
	//  “; ”
	'recordingProtocolRecordingType.A': 'A - Audio',
	'recordingProtocolRecordingType.V': 'V - Videoklip',
	recordingRegistration: 'Registrace nové nahrávky',
	cancelRecordingProtocolEntry: 'Zrušit zadávání nahr. protokolu ',
	cancelRecordingRegistration: 'Ukončit registraci nahrávky',
	reallyCancelRecordingRegistration: 'Opravdu ukončit registraci nahrávky?',
	createIsrcRecordingProtocol: 'Vyplnit nahrávací protokol',
	createCatalogRecordingProtocol: 'Přidat nahrávku do katalogu výrobce',
	createIsrcAndCatalogRecordingProtocol: 'Přidat nahrávku do katalogu výrobce a současně vyplnit nahrávací protokol',
	createIsrcRecordingProtocolHint: 'registruji pouze výkony výkonných umělců, nikoliv práva výrobce',
	createCatalogRecordingProtocolHint: 'registruji pouze práva výrobce',
	createIsrcAndCatalogRecordingProtocolHint: 'registruji práva výrobce i výkony výkonných umělců',
	recordingProtocolTypeSelection: 'Výběr typu protokolu',
	registerNewRecording: 'Zaregistrovat novou nahrávku ',
	recordingProtocols: 'Podané registrace nahrávek',
	registeredRecordings: 'Evidované nahrávky',
	backToBasicInfo: 'Zpět na základní údaje',
	recordingProtocolCount: 'Počet nahrávacích protokolů',
	proceedToRecordingProtocolSummary: 'Pokračovat na souhrn zadaných údajů',
	recordingProtocolSummary: 'Přehled zadaných údajů',
	backToLineup: 'Zpět na lineup',
	proceedToLineupEntry: 'Pokračovat na zadání lineupu',
	noUserHistoryMessage: 'Neevidujeme u uživatele žádné změny.',
	userPartyAdded: 'Přidání osoby',
	userPartyDeleted: 'Odstranění osoby',
	userModification: 'Změna údajů uživatele',
	currencies: 'Měny',
	CatalogRecording: 'Katalog nahrávek',
	reload: 'Aktualizovat',
	AffirmationDistributionResult: 'Výsledky vyúčtování ČP',
	cannotExportThereAreMissingExchangeRates: 'Export nelze provést, pro následující měny nejsou nadefinovány směnné kurzy: $currencies',
	cannotExportThereAreMissingExchangeRate: 'Export nelze provést, pro následující měnu není nadefinován směnný kurz: $currencies',
	producerSummary: 'Přehled výrobců',
	missingExchangeRates: 'Chybějící kurzy',
	'affirmationSubmissionItemType.C': 'Návštěvnost kin',
	'affirmationSubmissionItemType.B': 'Vysílání',
	'affirmationSubmissionItemType.S': 'Prodej',
	exportAllCompletedSubmissionsToExcel: 'Exportovat všechna dokončená podání do Excelu',
	reallySetStatusTo: 'Opravdu nastavit status na "$status"?',
	setStatusTo: 'Nastavit status na "$status"',
	conflictResolution: 'Řešení konfliktů',
	passToProducers: 'Předat výrobcům',
	refreshConflictsForDistributionPeriod: 'Aktualizovat konflikty za období $distributionPeriodId',
	passedToProducers: 'Předáno výrobcům',
	ignored: 'Ignorováno',
	conflictResolutionWillBeOpen: 'Opravy konfliktů bude možné provádět od *$fromDate*.',
	conflictResolutionIsClosed: 'Opravy konfliktů v tuto chvíli není možné provádět.',
	ignore: 'Ignorovat',
	waitingForYourDecision: 'Čeká na vaše vyhodnocení',
	resolved: 'Vyřešeno',
	submissionList: 'Podání',
	attendanceMismatch: 'Neshoda v návštěvnosti',
	runtimeMismatch: 'Neshoda ve stopáži',
	productionYearMismatch: 'Neshoda v roku výroby',
	sameDigitalSaleIncome: 'Shodný digitální prodej',
	samePhysicalSaleIncome: 'Shodný fyzický prodej',
	anomalies: 'Anomálie',
	conflicts: 'Konflikty',
	exportToExcel: 'Vyexportovat do Excelu',
	importFromExcel: 'Naimportovat z Excelu',
	'affirmationImport.existingDataWillBeReplaced': 'Opravdu chcete provést import?\n\nStávající data budou smazána a nahrazena daty z importovaného souboru.',
	duplicateEntry: 'Duplicitní záznam',
	correctionReasonIsMandatoryLong: 'Doplňte zdůvodnění opravy/doplnění pro "$title"',
	correctionReasonIsMandatory: 'Doplňte zdůvodnění opravy/doplnění kliknutím na tlačítko "Oprava" vpravo.',
	reopen: 'Znovu otevřít',
	reallyLeaveModifiedAffirmationSubmission: 'Opravdu chcete zavřít neuložené podání?\n\nProvedené změny budou zahozeny.',
	productionYearMustNotBeAfterReleaseYear: 'Neplatný rok výroby',
	comment: 'Poznámka',
	duplicateCinemaAttendanceEntries: 'Návštěvnost kin obsahuje duplicitní záznam: $duplicates',
	dragFileOrFiles: 'Přetáhnout soubor(y)',
	updatingBroadcastsFromCinemaAttendance: 'Načítám filmy z karty “Návštěvnost kin”..',
	updateBroadcastsFromCinemaAttendance: 'Načíst filmy z karty “Návštěvnost kin”',
	updateSalesFromCinemaAttendanceAndBroadcasts: 'Načíst záznamy z karty “Návštěvnost kin” a “Vysílání”',
	correctionAddition: 'Oprava/doplnění',
	clearFilter: 'Vyčistit filtr',
	noMatchingProgrammesFound: 'Nebyly nalezeny žádné odpovídající pořady.',
	noMatchingCinemaAttendancesFound: 'Nenalezeny žádné odpovídající záznamy.',
	countRowsAdded: 'Bylo přidáno $count záznamů.',
	nowRowsAdded: 'Nebyly přidány žádné záznamy.',
	rowsPerPage5to200: 'Počet záznamů na stránku (5-200)',
	noRecordsFound: 'Nenalezeny žádné záznamy',
	displayingTotalCountRecords: 'Zobrazeno $totalCount záznamů',
	displayingDisplayedCountOutOfTotalCountRecords: 'Zobrazeno $displayedCount z $totalCount záznamů',
	deleteRecord: 'Smazat záznam',
	affirmationSubmissionCannotBeCreatedAtThisMoment: 'V tuto chvíli nelze vytvářet nová podání ČP',
	createNewSubmission: 'Vytvořit nové podání',
	AffirmationSubmission: 'Podání ČP VZOZ',
	AffirmationSubmissionAdmin: 'Správa podání ČP VZOZ',
	newAffirmationSubmission: 'Nové podání ČP',
	attendanceMustNotBeNegative: 'Návštěvnost nesmí být záporná',
	runtimeMustNotBeNegative: 'Stopáž nesmí být záporná',
	submissionToDateMustBeGreaterThanSubmissionFromDate: 'Datum podání do musí být větší než datum podání od',
	conflictResolutionToDateMustBeGreaterThanConflictResolutionFromDate: 'Datum řešení konfliktů do musí být větší než datum řešení konfliktů od',

	'cellError.missing': 'Povinné pole',
	'cellError.invalidDate': 'Neplatný datum',
	'cellError.invalidSharePct': 'Neplatný podíl',
	'cellError.invalidProductionYear': 'Neplatný rok zveřejnění',
	'cellError.invalidAffirmationRecordingType': 'Neplatný typ',
	'cellError.invalidRuntime': 'Neplatná stopáž',
	'cellError.invalidTime': 'Neplatný čas',
	'cellError.invalidChannel': 'Neplatný kanál',
	'cellError.invalidAttendance': 'Neplatná návštěvnost',
	'cellError.invalidAmount': 'Neplatná částka',
	'cellError.invalidCurrency': 'Neplatná měna',
	importErrorHeader: 'Import "$fileName" obsahuje chyby. Opravte je a nahrajte soubor znovu.',
	'cellError.invalidNumber': 'Neplatné číslo',
	importingFile: 'Importuji soubor $fileName..',
	consolidatingFile: 'Zpracovávám soubor $fileName..',
	userExpired: 'Váš přístup do Portálu byl ukončen. Kontaktujte nás na adrese portal@intergram.cz',
	setBankIdentityUserConfirmation: 'Opravdu napojit bankovní identitu na uživatele $userName?\n\n$userInfo\n\nBude odeslán notifikační email na $emails.',
	onlyIntergramAndRaventiaUsersCanBeAdmins: 'Pouze uživatelé z Intergramu a Raventie mohou být administrátory',
	and: 'a',
	uploadUfd: 'Nahrát UFD',
	uploadPressdata: 'Nahrát Pressdata',
	basicInfo: 'Základní údaje',
	'submissionRole.PER': 'Výkonní umělci',
	'submissionRole.PRO': 'Výrobci',
	importSuccessful: 'Soubor $fileName byl úspěšně naimportován.',
	matchUser: 'Napojit uživatele',
	userNameMatch: 'Shoda uživatelského jména',
	selectOneFile: 'Vyberte jeden soubor',
	candidates: 'Kandidáti',
	loginAsUser: 'Přihlásit se jako uživatel',
	createUser: 'Vytvořit uživatele',
	newUser: 'Nový uživatel',
	userNameMustNotContainSpaces: 'Uživatelské jméno nesmí obsahovat mezery',
	createAndMatch: 'Vytvořit a napojit',
	profileIsLinkedToBankIdentity: 'Uživatel je propojen s bankovní identitou.',
	profileWasLinkedToBankIdentity: 'Uživatel byl (ale už není) propojen s bankovní identitou.',
	'unmatchedBankIdLoginMessage.line1': 'Autorizace se nezdařila.',
	'unmatchedBankIdLoginMessage.line2': 'Pokud máte jméno a heslo, přihlašte se níže. Tím dojde k propojení s Vaší bankovní identitou, přes kterou se budete moci příště přihlásit.',
	'unmatchedBankIdLoginMessage.line3': 'Případně vyčkejte na manuální ověření pracovníky INTERGRAM. Následně Vás budeme kontaktovat.',

	'unmatchedBankIdLoginMessage.userExpired': 'Uživatelský účet spojený s touto identitou je uzamčen. Vyčkejte, prosím, na autorizaci pracovníkem INTERGRAM, budete kontaktováni.',
	'unmatchedBankIdLoginMessage.generalError': 'Při přihlašování došlo k chybě.',

	includingDeleted: 'Včetně smazaných',
	termsOfService: 'Obecné podmínky',

	loginWithUserNameAndPassword: 'Přihlášení uživatelským jménem a heslem',
	loginWithBankId: 'Přihlásit se přes Bank iD',
	bankIdLoginBlockText: 'Nově můžete použít Bank iD, po kliknutí na odkaz stačí vybrat svou banku a přihlásit se stejně jako do svého internetového bankovnictví.',
	reallyDeleteBankIdentity: 'Opravdu smazat bankovní identitu?',
	unmatched: 'Nenapojené',
	matched: 'Napojené',
	deleted: 'Smazané',
	bankIdentities: 'Bankovní identity',
	removeBankIdentity: 'Odstranit bankovní identitu',
	reallyRemoveBankIdentity: 'Opravdu odstranit bankovní identitu?\n\nPo odstranění nebude možné se přes ni přihlašovat k tomuto uživatelskému účtu.',
	noBankIdentityConnectedToThisUserAccount: 'Váš uživatelský účet není propojen s žádnou bankovní identitou.\n\nPokud se chcete připojovat bankovní identitou, zvolte při přístím přihlášení možnost "Přihlášení přes Bank iD".',

	aboutPortal: 'O klientském portále',
	refresh: 'Aktualizovat',
	invalidPassword: 'Neplatné heslo',
	profile: 'Profil',
	rightHolderReward: 'Odměna držitele práv',
	'submissionTransition.NEW2SAVED_FOR_LATER': 'Vytvořeno a uloženo na později',
	'submissionTransition.NEW2SUBMITTED': 'Vytvořeno a odesláno ke zpracování',
	'submissionTransition.SUBMITTED': 'Odesláno ke zpracování',
	'submissionTransition.SUBMITTED2IN_PROGRESS': 'Zaměstnanec Intergramu přijal podání a pracuje na jeho zpracování',
	submissionStatusChange: 'Změna stavu podání',
	changeHistory: 'Historie změn',
	SubmissionAdmin: 'Správa podání',
	more: 'více',
	fileSubmission: 'Odeslat podání',
	setSubmissionStateTo: 'Nastavit stav na',
	attachANoteOrAFile: 'Připojte poznámku nebo přílohu',
	uploadingFile: 'Nahrávám soubor $fileName..',
	uploadingFileProgress: 'Nahrávám soubor $fileName..$progress%',
	selectAttachment: 'Vybrat přílohu',
	fileSizeSumLimitExceeded: 'Soubor(y) nelze nahrát, byla by překročena maximální velikost příloh ($limit)',
	singleFileSizeLimitExceeded: 'Soubor ($fileName) nelze nahrát, překračuje maximální velikost ($limit)',
	or: 'nebo',
	attachmentDragText: 'Přetáhněte sem soubor(y)',
	maxSize: 'max. velikost',
	list: 'Seznam',
	saveForLater: 'Uložit na později',
	Dashboard: 'Přehled',
	UsageReport: 'Užití a odměny',
	MyRecordings: 'Moje nahrávky',
	Submissions: 'Podání',
	Notifications: 'Notifikace',
	SystemSettings: 'Systémová nastavení',
	SessionLog: 'Log přihlášení',
	NotificationAdmin: 'Správa notifikací',
	UserProfile: 'Uživatelský profil',
	SystemMaintenance: 'Odstávky systému',
	UserAdmin: 'Správa uživatelů',
	AffirmationSubmissionSettings: 'Správa podání ČP',
	BankId: 'Bankovní identity',
	AuthenticationCode: 'Autorizační kódy',
	Submission: 'Podání',
	newSubmission: 'Nové podání',
	troubleChangingPasswordOrSigningIn: 'Máte potíže se změnou hesla či přihlášením?',
	'dashboard.subHeader.broadcaster': 'Vysílatel',
	'dashboard.subHeader.channel': 'Stanice',
	'dashboard.subHeader.audioVideo': 'Audio / Video',
	sendErrorMessage: 'Chyba odesílání',
	'authenticationErrorCode.-20056': 'Uživatel zadal neplatný kód',
	'authenticationErrorCode.-20057': 'Platnost kódu vypršela',
	forgottenPassword: 'Zapomněli jste heslo?',
	passwordChange: 'Změna hesla',
	passwordReset: 'Vytvoření nového hesla',
	passwordHasBeenChanged: 'Vaše heslo bylo změněno',
	passwordResetEmailSent: 'Na *$email* jsme odeslali odkaz pro změnu hesla.',

	userActivated: 'Uživatel byl aktivován $when',
	userActivationSent: 'Aktivační e-mail byl odeslán $when',
	passwordsDoNotMatch: 'Hesla se neshodují',
	createYourPortalPassword: 'Vytvořte si své heslo pro přihlášení do portálu.',
	passwordMustMeetTheseCriteria: 'Heslo musí splňovat',
	'pwd.min8Chars': 'minimální délka 8 znaků',
	'pwd.upperLower': 'minimálně jedno velké a jedno malé písmeno',
	'pwd.specialChars': 'minimálně jedno číslo či speciální znak',
	'pwd.passwordVerification': 'heslo a jeho ověření se shodují',
	'pwd.newPasswordVerification': 'nové heslo a jeho ověření se shodují',
	submit: 'Odeslat',
	nowYouCanLogIn: 'Nyní se můžete přihlásit!',
	activationSuccessful: 'Aktivace přístupu k portálu dokončena!',
	passwordCreation: 'Vytvoření hesla',
	back: 'Zpět',
	invalidSmsCode: 'Zadali jste neplatný SMS kód',
	invalidUserName: 'Neplatné uživatelské jméno',
	smsCodeExpired: 'Platnost SMS kódu vypršela',
	invalidActivationCode: 'Neplatný aktivační kód',
	activationCodeExpired: 'Platnost aktivačního kódu vypršela',
	smsNotReceived: 'Nepřišla vám SMS?',
	enterSmsCode: 'Zadejte prosím SMS kód pro přihlášení, který jsme odeslali na Váš *mobilní telefon* ($phone).',
	passwordResetHint: 'Vyplňte prosím Vaše uživatelské jméno. Na Váš *email* zašleme odkaz, jehož pomocí heslo změníte.',
	invalidCredentials: 'Neplatné přístupové údaje',
	smsAuthentication: 'SMS ověření',
	errorSendingLoginCodeSms: 'Při odesílání SMS s kódem pro přihlášení došlo k chybě.',
	welcomeHeader: 'Vítejte na klientském portále',
	contractNeededForAccess: 'Pro přístup do klientského portálu je třeba mít uzavřenou smlouvu s Intergramem.',
	iHaveAContract: 'Mám smlouvu',
	iDontHaveAContract: 'Nemám smlouvu',
	needAdvice: 'Potřebujete poradit?',
	troubleSigningIn: 'Mátě potíže s přihlášením?',
	loginNoun: 'Přihlášení',
	login: 'Přihlásit se',
	iAmARegisteredUser: 'Mám přístupové údaje do klientského portálu.',
	newContract: 'Uzavření smlouvy s Intergramem',
	iWantAContract: 'Nemám uzavřenou smlouvu a mám zájem využívat klientský portál Intergramu.',
	sendActivationLink: 'Poslat aktivační link',
	yes: 'Ano',
	no: 'Ne',
	activationLinkSent: 'Aktivační link byl úspěšně odeslán',
	reallySendActivationLink: 'Opravdu poslat aktivační link?',
	duplicateUserName: 'Uživatel s tímto uživatelským jménem už existuje',
	terminate: 'Ukončit',
	reactivate: 'Obnovit',
	'new.user': 'Nový uživatel',
	'usageReportFlag_P.short': 'P',
	usageReportFlag_P: 'Prodej',
	'usageReportFlag_R.short': 'R',
	usageReportFlag_R: 'Repríza',
	inDetail: 'Detailně',
	aggregatedItems: 'Agregované položky',
	'usageReport.time_used_sum.subText': 'stopáže',
	'usageReport.spins_sum.subText': 'užití',
	'usageReport.ip_gross_amount_sum.subText': 'Kč (Brutto)',
	'usageReport.np_gross_amount_sum.subText': 'Kč (Brutto)',
	backToOverview: 'Zpět na seznam',
	cancelChanges: 'Zrušit změny',
	maintenanceNotification: 'Dne *$day* dojde k odstávce systému v čase *$timeFrom* - *$timeTo* z důvodu jeho aktualizace. Před jejím započtením bude vaše práce uložena.',
	performerSignIn: 'Web umělců',
	producerSignIn: 'Web výrobců',
	youNeedToSignIn: 'Pro vstup na portál se musíte přihlásit nebo registrovat.',
	stayLoggedIn: 'Zůstat přihlášen',
	sessionLogoutInLessThan: 'Budete odhlášeni za méně než',
	'minutes.1': 'minutu',
	'minutes.2': 'minuty',
	'minutes.3': 'minuty',
	'minutes.4': 'minuty',
	'minutes.x': 'minut',
	doYouWantToSaveOpenSubmission: 'Chcete uložit rozpracované podání?',
	saveAndClose: 'Uložit a zavřít',
	doCancelSubmission: 'Ano, zrušit podání',
	reallyCancelSubmission: 'Opravdu chcete zrušit podání?',
	cancelSubmission: 'Zrušit podání',
	close: 'Zavřít',
	closeWithoutSaving: 'Zavřít bez uložení',
	youHaveMadeSubmissionChanges: 'Provedli jste v otevřeném podání změny, chcete je před zavřením uložit?',
	anotherModifiedSubmission: 'Máte otevřené jiné rozpracované podání, chcete jej uložit a otevřít nové?',
	youHaveBeenLoggedOut: 'Byli jste odhlášeni',
	dashboardNoDataMessage: 'Nemáte k dispozici žádné odměny.',
	usageReportNoDataMessage: 'Nemáte žádná užití.',
	myRecordingsNoDataMessage: 'Nemáte žádné nahrávky.',
	saveAndOpenNew: 'Uložit a otevřít nové',
	openWithoutSaving: 'Otevřít nové bez uložení',
	rowCount: 'Počet záznamů',
	next: 'Další',
	previous: 'Předchozí',
	processingRequest: 'Zpracovávám požadavek..',
	czk: 'Kč',
	delete: 'Smazat',
	help: 'Nápověda',
	showAltNames: 'zobrazit alternativní jména',
	altNames: 'Alternativní jména',
	'submissionStatusGroup.OPEN': 'Rozpracovaná podání',
	'submissionStatusGroup.SUBMITTED': 'Odeslaná podání',
	'submissionStatusGroup.CLOSED': 'Uzavřená podání',
	hide: 'skrýt',
	logout: 'Odhlásit se',
	noItemsFound: 'Nenalezeny žádné položky',
	save: 'Uložit',
	ok: 'OK',
	personalInfo: 'Osobní údaje',
	roleList: 'Seznam rolí',
	cancel: 'Storno',
	displayedRecordings: 'Zobrazené nahrávky',
	displayedSubmissions: 'Zobrazená podání',
	submissionCount: 'Počet podání',
	recordingCount: 'Počet nahrávek',
	pageNumber: 'Přejít na stránku',
	rowsPerPage: 'Záznamů na stránku',
	exportSelectionToCSV: 'Exportovat výběr do CSV',
	'childRoleRelType.MEM': 'Člen skupiny',
	'childRoleRelType.ADM': 'Společný zástupce skupiny',
	'footer.socialNetworks': 'Zůstaňte s námi v kontaktu na sociálních sítích',
	'recordingTypeA': 'Zvuk',
	'recordingTypeV': 'Video',
	'distType.IP': 'IP (Identifikovatelný)',
	'distType.NP': 'NP (Neidentifikovatelný)',
	'audioVideo.A': 'Zvuk',
	'audioVideo.V': 'Video',
	'recordingSource.isrcProtocol': 'Z nahrávacích protokolů',
	'recordingSource.other': 'Z ostatních zdrojů',
	readingItems: 'Načítám položky',
	mandatoryField: 'Povinné pole',
	maintenanceToMustBeGreaterThanMaintenanceFrom: 'Konec odstávky musí být po jejím začátku',
	notificationFromDateMustBeLessThanMaintenanceFrom: 'Notifikace od musí před začátkem odstávky',
	maintenanceFromAndToMustBeSameDay: 'Začátek a konec odstávky musí být ve stejný den',
	toDateMustBeGreaterThanFromDate: 'Konec notifikace musí být po jejím začátku',
	shareMustBeBetween0And100: 'Podíl musí být mezi 0 a 100',
	productionYearMustBeBetweenMinAndMax: 'Rok výroby musí být mezi $min a $max.',
	publicationYearMustBeBetweenMinAndMax: 'Rok zveřejnění musí být mezi $min a $max.',

	'cellError.invalidProductionYear.affSub.2016': 'Rok zveřejnění musí být mezi 1965 a 2016.',
	'cellError.invalidProductionYear.affSub.2017': 'Rok zveřejnění musí být mezi 1966 a 2017.',
	'cellError.invalidProductionYear.affSub.2018': 'Rok zveřejnění musí být mezi 1967 a 2018.',
	'cellError.invalidProductionYear.affSub.2019': 'Rok zveřejnění musí být mezi 1968 a 2019.',
	'cellError.invalidProductionYear.affSub.2020': 'Rok zveřejnění musí být mezi 1969 a 2020.',
	'cellError.invalidProductionYear.affSub.2021': 'Rok zveřejnění musí být mezi 1970 a 2021.',
	'cellError.invalidProductionYear.affSub.2022': 'Rok zveřejnění musí být mezi 1971 a 2022.',
	'cellError.invalidProductionYear.affSub.2023': 'Rok zveřejnění musí být mezi 1972 a 2023.',
	'cellError.invalidProductionYear.affSub.2024': 'Rok zveřejnění musí být mezi 1973 a 2024.',
	'cellError.invalidProductionYear.affSub.2025': 'Rok zveřejnění musí být mezi 1974 a 2025.',
	'cellError.invalidProductionYear.affSub.2026': 'Rok zveřejnění musí být mezi 1975 a 2026.',
	'cellError.invalidProductionYear.affSub.2027': 'Rok zveřejnění musí být mezi 1976 a 2027.',
	'cellError.invalidProductionYear.affSub.2028': 'Rok zveřejnění musí být mezi 1977 a 2028.',
	'cellError.invalidProductionYear.affSub.2029': 'Rok zveřejnění musí být mezi 1978 a 2029.',
	'cellError.invalidProductionYear.affSub.2030': 'Rok zveřejnění musí být mezi 1979 a 2030.',
	'cellError.invalidProductionYear.affSub.2031': 'Rok zveřejnění musí být mezi 1980 a 2031.',
	'cellError.invalidProductionYear.affSub.2032': 'Rok zveřejnění musí být mezi 1981 a 2032.',
	'cellError.invalidProductionYear.affSub.2033': 'Rok zveřejnění musí být mezi 1982 a 2033.',
	'cellError.invalidProductionYear.affSub.2034': 'Rok zveřejnění musí být mezi 1983 a 2034.',

	productionPublicationYearMustBeBetweenMinAndMax: 'Rok výroby/zveřejnění musí být mezi $min a $max.',
	'new.systemMaintenance': 'Nová odstávka systému',
	'new.notification': 'Nová notifikace',
	'ynBoolean.Y': 'Ano',
	'ynBoolean.N': 'Ne',
	'validationMessageHeader': 'Opravte prosím nejdříve chyby:',
	'validationIgnorableErrors': 'Formulář obsahuje chyby, které nebrání uložení:',
	'validationIgnorableErrors2': 'Formulář obsahuje i chyby, které nebrání uložení:',
	'validationWarnings': 'Upozornění',

	saveAnyway: 'Přesto uložit',
	backToForm: 'Zpět na formulář',
	isAMandatoryField: ' je povinné pole',

};

const columnTexts = {
	notification_channel: 'Kanál',
	text: 'Text',
	maintenanceFrom: 'Začátek',
	maintenanceTo: 'Konec',
	'systemMaintenance.fromDate': 'Začátek',
	'systemMaintenance.toDate': 'Konec',
	from_date: 'Od',
	to_date: 'Do',
	logoutWarningThreshold: 'Jak dlouho před odhlášením zobrazit upozornění (minuty)',
	sessionDurationInMinutes: 'Délka sessiony (minuty)',
	account_category: 'Kategorie práv',
	usage_year: 'Rok užití',
	income_type: 'Typ příjmu',
	reward_amount: 'Výše odměny',
	reward_netto: 'K vyplacení',
	'categoryName.dashboard': 'Kategorie práv',
	'effectivePeriodId.dashboard': 'Rok užití',
	'distType.dashboard': 'Typ příjmu',
	'brutto.dashboard': 'Výše odměny',
	'netto.dashboard': 'K vyplacení',
	total_netto_reward: 'Celková odměna k vyplacení',
	highest_reward_category: 'Nejvyšší odměny z kategorie',
	top_channel: 'Nejvyšší odměna na stanici',
	most_profitable_recording: 'Nejvýdělečnější nahrávka',
	person_group: 'Osoba | Skupina',
	role: 'Role',
	distribution_period: 'Distribuční období',

	nameAndSurname: 'Jméno a příjmení',
	session_id: 'Id',
	user: 'Uživatel',
	proxy_user: 'Proxy uživatel',
	login_type: 'Typ přihlášení',
	login_time: 'Čas přihlášení',
	logout_time: 'Čas odhlášení',
	last_access_time: 'Poslední přístup',

	recording: 'Nahrávka',
	production_release_year: 'Rok výroby (vydání)',
	production_publication_year: 'Rok výroby / zveřejnění',
	length: 'Stopáž',
	audio_video: 'Zvuk/Video',
	isrc: 'ISRC',

	from: 'Od',
	to: 'Do',
	'from.lower': 'od',
	'to.lower': 'do',
	licence: 'Licence',

	profile_name: 'Název profilu',
	first_name: 'Jméno',
	last_name: 'Příjmení',
	date_of_birth: 'Datum narození',
	profile_type: 'Typ profilu',
	email: 'E-mail',
	phone: 'Telefon',
	street_and_house_number: 'Ulice a č.p.',
	city: 'Město',
	zip_code: 'PSČ',
	day: 'Den',
	notification_from_date: 'Notifikace od',
	comments: 'Komentář',
	production_year: 'Rok výroby',
	release_year: 'Rok vydání',
	is_isrc_protocol: 'ISRC protokol',
	is_deleted: 'Smazáno',
	is_active: 'Aktivní',
	created_when: 'Vytvořeno',
	edited_when: 'Upraveno',
	'edited_when.affirmationSubmission': 'Naposledy změněno',
	'production_year.affirmationCinemaAttendance': 'Rok zveřejnění',
	'production_year.affirmationBroadcast': 'Rok zveřejnění',
	'production_year.affirmationSale': 'Rok zveřejnění',
	'production_year.affirmationAttachment': 'Rok zveřejnění',
	maintenance: 'Odstávka',
	station: 'Stanice',
	last_modified: 'Poslední změna',
	usage_date: 'Datum a čas užití',
	recording_type_id: 'Zvuk / Video',
	recording_id: 'Id nahrávky',
	time_used: 'Užitá stopáž',
	spins: 'Počet užití',
	ip_gross_amount: 'Částka IP',
	np_gross_amount: 'Částka NP',
	is_rerun: 'Repríza',
	is_sale: 'Prodej',
	title: 'Titul',
	subtitle: 'Podtitul',
	broadcaster: 'Vysílatel',
	party: 'Osoba',
	parties: 'Osoby',
	'share_pct.movieProducerDistributionResult': 'Koprodukční podíl',
	'from_date.authenticationCode': 'Platnost od',
	'to_date.authenticationCode': 'Platnost do',
	used_when: 'Použito',
	authentication_code_type: 'Typ kódu',
	authentication_code_status: 'Stav',
	authentication_code: 'Kód',
	sent_to: 'Posláno na',
	'born.short': 'nar.',
	user_name: 'Uživatelské jméno',
	display_name: 'Jméno',

	film_id: 'ID titulu',
	total_sale_income: 'Celkové prodeje',
	broadcast_effective_runtime: 'Celková odvysílaná stopáž (přepočtená)',
	gross_amount: 'Brutto odměna',
	'gross_amount.movieProducerDistributionResult': 'Celková odměna (btto)',
	language: 'Jazyk',
	activated: 'Aktivováno',
	'languageId.form': 'Jazyk',
	smsCode: 'SMS kód',
	submission_from_date: 'Podání od',
	submission_to_date: ' Podání do',
	conflict_resolution_from_date: 'Řešení konfliktů od',
	conflict_resolution_to_date: 'Řešení konfliktů do',
	password: 'Heslo',
	attachments: 'Přílohy',
	submission_id: 'Id podání',
	password_verification: 'Znovu heslo',
	new_password: 'Nové heslo',
	new_password_verification: 'Ověření nového hesla',
	old_password: 'Stávající heslo',
	detail: 'Detail',
	'name.submission': 'Vlastní označení',
	'type.submission': 'Předmět podání',
	'role_id.submission': 'Podání za osobu',
	'role_id.recordingProtocol': 'Podání za osobu',
	'comments.submission': 'Poznámka',
	'role_id.affirmationSubmission': 'Podání za osobu',
	'roleId.affirmationSubmission': 'Podání za osobu',
	'submitted_when.submission': 'Odesláno (vytvořeno)',
	'party_id.submission': 'Podání za osobu',
	'party_id.recordingProtocol': 'Podání za osobu',
	'party_id.affirmationSubmission': 'Podání za osobu',
	status: 'Stav',
	submitted_by: 'Podal(a)',
	brutto: 'Brutto',
	submission_status: 'Stav',
	submission_type: 'Typ',

	cinema_attendance_reward: 'Odměna dle návštěvnosti (btto)',
	broadcast_reward: 'Odměna dle stopáže (btto)',
	sale_reward: 'Odměna dle prodejů (btto)',

	isan: 'ISAN',
	netto: 'Netto',
	total_share_pct: 'Celkový podíl',
	bank_identity_id: 'Id',
	matched_user: 'Napojený uživatel',
	name: 'Jméno',
	birth_date: 'Datum narození',
	phone_number: 'Telefon',
	birth_number: 'Rodné číslo',
	primary_nationality: 'Národnost',
	deleted_when: 'Smazáno',
	userMatchedWhen: 'Uživatel napojen',
	is_system_admin: 'Systémový administrátor',
	is_submission_admin: 'Správce podání',
	ufd: 'UFD',
	pressdata: 'Pressdata',
	submission_date_range: 'Podání od - do',
	distribution_period_id: 'Distribuční období',
	original_title: 'Původní titul',
	cinema_attendance_record_count: 'Poč. zázn. - návštěvnost',
	broadcast_record_count: 'Poč. zázn. - vysílání',
	sale_record_count: 'Poč. zázn. - prodej',
	cinema_attendance: 'Návštěvnost kin',
	producer: 'Výrobce',
	producer_id: 'Výrobce',
	main_artist: 'Hlavní umělec',
	broadcast: 'Vysílání',
	correction: 'Oprava',
	submission_on_behalf_of: 'Podání za',
	sale: 'Prodej',
	distributor: 'Distributor',
	release_date: 'Premiéra',
	country: 'Země',
	attendance: 'Návštěvnost',
	channel: 'Kanál',
	broadcast_time: 'Čas vysílání',
	imported_from_excel: 'Naimportováno z Excelu',
	year: 'Rok',
	runtime: 'Stopáž',
	type: 'Typ',
	row_id: 'Číslo řádku',
	recording_name: 'Název díla',
	original_recording_name: 'Originální název snímku',
	country_id: 'Země',
	share_pct: 'Podíl',
	creator_role_id: 'Role',
	ufd_attendance: 'Návštěvnost dle UFD',
	producer_name: 'Název výrobce',
	total_attendance: 'Celková návštěvnost',
	total_runtime: 'Celková stopáž',
	currency_id: 'Měna',
	total_physical_sale_income: 'Celkový příjem z fyzických prodejů',
	total_digital_sale_income: 'Celkový příjem z digitálních prodejů',
	affirmation_recording_type_id: 'Druh záznamu',
	affirmation_recording_type: 'Druh záznamu',
	reason: 'Zdůvodnění',
	correctionReason: 'Zdůvodnění opravy/doplnění',
	broadcast_start_time: 'Datum a čas zahájení vysílání',
	physical_sale_income: 'Příjem za fyzický prodej nosičů bez DPH',
	digital_sale_income: 'Příjem z digitálního prodeje bez DPH',
	currency: 'Měna',
	affSumTotalRuntime: 'Celková vysílaná stopáž',
	affSumTotalPhysicalSaleIncome: 'Celkový příjem za fyzický prodej nosičů bez DPH',
	affSumTotalDigitalSaleIncome: 'Celkový příjem z digitálního prodeje (vč. streamingu) bez DPH',
	affSumTotalAttendance: 'Celková návštěvnost v kinech',
	note: 'Poznámka',
	currrencyId: 'Měna',
	exchangeRate: 'Směnný kurz',
	added_by: 'Přidal(a)',
	added_when: 'Přidáno',
	deleted_by: 'Smazal(a)',
	language_id: 'Jazyk',
	runtime_minutes: 'Stopáž (v minutách)',
	'runtime.affirmationBroadcast': 'Stopáž (v minutách)',

	processed_by: 'Zpracovává',
	bc_run_type_id: 'Typ distribuce',
	period: 'Období',
	net_amount: 'Netto odměna',
	withholding_tax: 'Srážková daň',
	cmo_name: 'Název ZKS',

	'producer.tabularCatalog':'Výrobce',
	'label.tabularCatalog':'Label',
	'title.tabularCatalog':'Titul nahrávky',
	'subtitle.tabularCatalog':'Podtitul, verze',
	'alt_title.tabularCatalog':'Alternativní název',
	'isrc.tabularCatalog':'ISRC',
	pin_dob: 'RČ/dat.nar.',
	'album.tabularCatalog':'Název alba nebo EP',
	'runtime_min.tabularCatalog':'Stopáž minuty',
	'runtime_sec.tabularCatalog':'Stopáž vteřiny',
	'recording_type_id.tabularCatalog':'Audio / videoklip',
	'licence_share_pct.tabularCatalog':'Koprodukce',
	'main_artist.tabularCatalog':'Hlavní interpret',
	'performer1_name.tabularCatalog':'Interpret1',
	'performer1_share_pct.tabularCatalog':'Podíl - interpret1',
	'performer1_performance.tabularCatalog':'Výkon - interpret1',
	'performer2_name.tabularCatalog':'Interpret2',
	'performer2_share_pct.tabularCatalog':'Podíl - interpret2',
	'performer2_performance.tabularCatalog':'Výkon - interpret2',
	'performer3_name.tabularCatalog':'Interpret3',
	'performer3_share_pct.tabularCatalog':'Podíl - interpret3',
	'performer3_performance.tabularCatalog':'Výkon - interpret3',
	'performer4_name.tabularCatalog':'Interpret4',
	'performer4_share_pct.tabularCatalog':'Podíl - interpret4',
	'performer4_performance.tabularCatalog':'Výkon - interpret4',
	'performer5_name.tabularCatalog':'Interpret5',
	'performer5_share_pct.tabularCatalog':'Podíl - interpret5',
	'performer5_performance.tabularCatalog':'Výkon - interpret5',
	'author_music.tabularCatalog':'Autor hudby',
	'author_lyrics.tabularCatalog':'Autor textu',
	'genre_id.tabularCatalog':'Žánr',
	'production_year.tabularCatalog':'Rok výroby',
	'release_year.tabularCatalog':'Rok prvního vydání',
	'recording_country_id.tabularCatalog':'Země výroby',
	'licence_from_date.tabularCatalog':'Platnost licence 1',
	'licence_to_date.tabularCatalog':'Platnost licence 2',
	'ai_generated.tabularCatalog':'Hudba generovaná AI',

	'producer.recordingProtocol': 'Výrobce/label',
	'main_artist.recordingProtocol': 'Hlavní umělec/skupina',
	'album.recordingProtocol': 'Název alba',
	'title.recordingProtocol': 'Název nahrávky',
	'subtitle.recordingProtocol': 'Podtitul/verze',
	'release_year.recordingProtocol': 'Rok prvního vydání/zveřejnění',
	'production_year.recordingProtocol': 'Rok vzniku',
	'length.recordingProtocol': 'Stopáž (mm:ss)',
	'recording_country_id.recordingProtocol': 'Země vzniku',
	'countryId.recordingProtocol': 'Země trv. pobytu',

	producers: 'Výrobci',
	genre_id: 'Druh nahrávky',
	recording_country_id: 'Země vzniku nahrávky',
	'recordingTypeId.recordingProtocol': 'Typ nahrávky',
	performer_total_share: 'Celkový podíl (%)',
	share: 'Podíl (%)',
	'isPerformerLineupFinal.recordingProtocol': 'Znám kompletní lineup a osobní údaje všech umělců',
	is_ma: 'Hlavní umělec',
	is_main_artist_member: 'Hlavní umělec',
	pin: 'Rodné číslo',
	producer_codes: 'Kódy výrobce',
	share_or_role: 'Podíl / role',
	label: 'Label',
	album: 'Album',
	performance: 'Výkon',
	admin_comments: 'Poznámky správce',
	document_name: 'Název dokumentu',
	document_no: 'Číslo dokumentu',
	closure_id: 'Číslo uzávěrky',
	amount: 'Částka',
	last_submitted: 'Naposledy odesláno',

	intergram_comment: 'Komentář Intergramu',
};

const l10n = {
	phrases,
	columnTexts
};

export default l10n;
